import {
  DEFAULT_OUTDOOR_SUN_TIME,
  isValidOutdoorSunTime,
  outdoorSunLocationFromFloorplan
} from './outdoor_sun_service.js';

const OUTDOOR_SHADOW_INTENSITIES = Object.freeze(['low', 'medium', 'high']);
const DEFAULT_OUTDOOR_SHADOW_INTENSITY = 'medium';
const DEFAULT_OUTDOOR_SUN_BRIGHTNESS = 100;

function normalizeOutdoorShadowIntensity(value) {
  const key = String(value || '').trim().toLowerCase();
  return OUTDOOR_SHADOW_INTENSITIES.includes(key) ? key : DEFAULT_OUTDOOR_SHADOW_INTENSITY;
}

function normalizeOutdoorSunBrightness(value) {
  const number = Number(value);
  if (!Number.isFinite(number)) return DEFAULT_OUTDOOR_SUN_BRIGHTNESS;
  return Math.max(40, Math.min(180, Math.round(number)));
}

function normalizeOutdoorEnvironment(data = {}, floorplan = null, legacySun = null) {
  const source = data && typeof data === 'object' ? data : {};
  const sunSource = legacySun && typeof legacySun === 'object' ? legacySun : {};
  const location = outdoorSunLocationFromFloorplan(floorplan);
  const selectedTime = isValidOutdoorSunTime(source.sunTime)
    ? source.sunTime
    : (isValidOutdoorSunTime(sunSource.selectedTime) ? sunSource.selectedTime : DEFAULT_OUTDOOR_SUN_TIME);
  return {
    enabled: source.enabled !== false,
    skyEnabled: true,
    shadowsEnabled: true,
    shadowIntensity: DEFAULT_OUTDOOR_SHADOW_INTENSITY,
    sunBrightness: normalizeOutdoorSunBrightness(source.sunBrightness ?? sunSource.sunBrightness),
    sunTime: selectedTime,
    locationSource: location.source,
    latitude: location.latitude,
    longitude: location.longitude,
    realisticEnvironment: true
  };
}

function outdoorEnvironmentSourceLabel(settings = {}) {
  return settings.locationSource === 'map' ? 'Position aus Karte' : 'Default: Zürich';
}

function outdoorEnvironmentToSunSimulation(settings = {}) {
  return {
    enabled: settings.enabled !== false,
    selectedTime: isValidOutdoorSunTime(settings.sunTime) ? settings.sunTime : DEFAULT_OUTDOOR_SUN_TIME,
    latitude: Number.isFinite(Number(settings.latitude)) ? Number(settings.latitude) : undefined,
    longitude: Number.isFinite(Number(settings.longitude)) ? Number(settings.longitude) : undefined,
    source: settings.locationSource === 'map' ? 'map' : 'default-zurich'
  };
}

export {
  OUTDOOR_SHADOW_INTENSITIES,
  DEFAULT_OUTDOOR_SHADOW_INTENSITY,
  DEFAULT_OUTDOOR_SUN_BRIGHTNESS,
  normalizeOutdoorShadowIntensity,
  normalizeOutdoorSunBrightness,
  normalizeOutdoorEnvironment,
  outdoorEnvironmentSourceLabel,
  outdoorEnvironmentToSunSimulation
};
